import { GOOGLE, LINKEDIN, META, TIKTOK } from "../../utils/constants";
import {
  optionsAdsCampaignObjectivesLinkedin,
  optionsAdsCampaignObjectivesMeta,
  optionsAdsCampaignObjectivesTikTok,
  optionsCampaignsTypeGoogleAds,
} from "../../utils/options";
import {
  isEmptyPlatformDefaultsValue,
  pickPlatformDefaultsLoadData,
} from "../../utils/platformDefaults/platformDefaultsSavedFields";

const IDENTITY_FIELD_KEYS = ["integrationID", "adAccountID"];

const OBJECTIVE_OPTIONS_BY_PLATFORM = {
  [META]: optionsAdsCampaignObjectivesMeta,
  [TIKTOK]: optionsAdsCampaignObjectivesTikTok,
  [GOOGLE]: optionsCampaignsTypeGoogleAds,
  [LINKEDIN]: optionsAdsCampaignObjectivesLinkedin,
};

const shouldApplyValue = ({ key, value }) => {
  if (key === "useFBPageAsIG") {
    return typeof value === "boolean";
  }
  return !isEmptyPlatformDefaultsValue(value);
};

const isValidObjectiveForPlatform = ({ platform, objective }) => {
  const options = OBJECTIVE_OPTIONS_BY_PLATFORM[platform] || [];
  return options.some((option) => option.value === objective);
};

const getOrderedFieldKeys = ({ loadData }) => {
  const keys = Object.keys(loadData);
  const identityKeys = IDENTITY_FIELD_KEYS.filter((key) => keys.includes(key));
  const remainingKeys = keys.filter(
    (key) => !IDENTITY_FIELD_KEYS.includes(key)
  );

  return [...identityKeys, ...remainingKeys];
};

export const applyPlatformDefaultsToGenerateCampaign = ({
  platform,
  data = {},
  setValue,
}) => {
  const loadData = pickPlatformDefaultsLoadData({ data });
  const orderedKeys = getOrderedFieldKeys({ loadData });

  orderedKeys.forEach((key) => {
    const value = loadData[key];

    if (!shouldApplyValue({ key, value })) {
      return;
    }

    if (
      key === "objective" &&
      !isValidObjectiveForPlatform({ platform, objective: value })
    ) {
      return;
    }

    setValue(key, value);
  });
};
